// extracted by mini-css-extract-plugin
export default {"purposeInput":"revenueSharingForm_purposeInput__BEv4f","countLimit":"revenueSharingForm_countLimit__MlJC5","percentageInput":"revenueSharingForm_percentageInput__3lEfq"};